module.exports = __webpack_public_path__ + "static/media/ClassicLong.36d3a5d2.png";